(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(26);
	
	__webpack_require__(9);
	
	__webpack_require__(31);
	
	__webpack_require__(35);
	
	var trackUtils = __webpack_require__(9);
	
	trackUtils.exportRootVars();
	trackUtils.exportComscoreVars();

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  /**
	   * write img element with error to track exceptions in kibana
	   * @param key
	   * @param message
	   * @return {HTMLImageElement}
	   */
	  imgTrack: function imgTrack(key, message) {
	    var today = new Date(),
	        date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate(),
	        time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds(),
	        dateTime = date + '-' + time,
	        src = '/comun/img/dtm-track.jpg',
	        querystring = encodeURI('key=' + key + '&datetime=' + dateTime + '&message=' + message),
	        img = document.createElement('img');
	    img.src = src + '?' + querystring;
	    return img;
	  },
	  exportRootVars: function exportRootVars() {
	    for (var key in window.vocento.tracking.root) {
	      if (vocento.tracking.root.hasOwnProperty(key)) {
	        window[key] = vocento.tracking.root[key];
	      }
	    }
	  },
	  exportComscoreVars: function exportComscoreVars() {
	    /** solo exportamos algunas variables, ya que VTM tiene prioridad sobre las vocvars y pisariamos sus valores */
	    window.voc_ate = window.vocento.tracking.comscore.voc_ate;
	    window.voc_top = window.vocento.tracking.comscore.voc_top;
	    window.voc_site = window.vocento.tracking.comscore.voc_site;
	    window.voc_tcnew = window.vocento.tracking.comscore.voc_tcnew;
	    window.voc_tc = window.vocento.tracking.comscore.voc_tc;
	    window.voc_se = window.vocento.tracking.comscore.voc_se;
	    window.voc_au = window.vocento.tracking.comscore.voc_au;
	    window.voc_s1 = window.vocento.tracking.comscore.voc_s1;
	    window.voc_s2 = window.vocento.tracking.comscore.voc_s2;
	    window.voc_s3 = window.vocento.tracking.comscore.voc_s3;
	    window.voc_s4 = window.vocento.tracking.comscore.voc_s4;
	  },
	  setTrackBuscadorPlaySummum: function setTrackBuscadorPlaySummum(TagManager) {
	    var main = window.document.getElementsByTagName('main');
	    if (main.length > 0) {
	      var keywords = main[0].getAttribute('data-keywords');
	      var num_entries = main[0].getAttribute('data-num-entries');
	      var buscador = main[0].getAttribute('data-buscador');
	      if (keywords !== null && keywords !== '') {
	        TagManager.set({
	          keyword: this.kebabCase(keywords),
	          tipoBuscador: 'buscador-' + buscador,
	          errorBusqueda: num_entries == 0 ? 'la-busqueda-no-obtuvo-ningun-resultado' : '',
	          nResultados: num_entries
	        });
	      }
	    }
	  },
	  kebabCase: function kebabCase(string) {
	    var result = string;
	    // Convert camelCase capitals to kebab-case.
	    result = result.replace(/([a-z][A-Z])/g, function (match) {
	      return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
	    });
	    // Convert non-camelCase capitals to lowercase.
	    result = result.toLowerCase();
	    // Convert non-alphanumeric characters to hyphens
	    result = result.replace(/[^-a-z0-9]+/g, '-');
	    // Remove hyphens from both ends
	    result = result.replace(/^-+/, '').replace(/-$/, '');
	    return result;
	  }
	};

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	'use strict';
	
	/** fake functions to legacy rendered news */
	window.lzld = function () {
	    return false;
	};
	
	window.ads = {
	    printAds: function printAds(params) {
	        return false;
	    }
	};
	
	window.pintoValoracion = false;
	window.cargarValoracion = function () {
	    var botonValoracion = Voonto.$('#enviar_valoracion');
	    botonValoracion.hide(); // Se oculta el botón hasta que Gigya no se cargue correctamente
	    window.pintoValoracion = true;
	    return false;
	};

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	'use strict';
	
	if (vocento.tracking.root.httpStatus !== '404') {
	    (function (w, d, s, l, i) {
	        w[l] = w[l] || [];
	        /** disabled start by vtm */
	        /** w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); */
	        var f = d.getElementsByTagName(s)[0],
	            j = d.createElement(s),
	            dl = l != 'dataLayer' ? '&l=' + l : '';
	        j.async = true;
	        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
	        f.parentNode.insertBefore(j, f);
	    })(window, document, 'script', 'dataLayer', vocento.tracking.config.gtmKey);
	}

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trackUtils = __webpack_require__(9);
	
	try {
	  /** exclude back view */
	  if (typeof history.state === 'undefined' || history.state === null || typeof history.state.lastSectionView === 'undefined' || history.state.lastSectionView === 'main') {
	
	    Voonto.ready.then(function (app) {
	      app.when('vtm:ready').then(function () {
	        try {
	          var tracking = window.vocento.tracking;
	
	          /** default values set ******************************************************************************************/
	          TagManager.set({
	            seccion: tracking.comscore.voc_se,
	            subseccion1: tracking.comscore.voc_s1,
	            subseccion2: tracking.comscore.voc_s2,
	            subseccion3: tracking.comscore.voc_s3,
	            subseccion4: tracking.comscore.voc_s4,
	            titular: tracking.comscore.voc_tn,
	            tipoDominio: tracking.comscore.voc_pr,
	            edicion: tracking.comscore.voc_ed,
	            tipoContenido: tracking.comscore.voc_tc,
	            tipoContenidoA: tracking.comscore.voc_tcnew,
	            plataformaContenido: tracking.comscore.voc_pl,
	            sistemaPublicacion: tracking.comscore.voc_pu,
	            fechaPrimeraPublicacion: tracking.comscore.voc_fep,
	            fechaModificacion: tracking.comscore.voc_fem,
	            idioma: tracking.comscore.voc_idi,
	            IDEvolok: tracking.comscore.voc_pw_pid,
	            firmaAutor: tracking.comscore.voc_au,
	            origenContenido: tracking.comscore.voc_or,
	            topics: tracking.comscore.voc_top
	          });
	
	          /** only home or home section sets ******************************************************************************/
	          if (tracking.comscore.voc_tc === 'portada' || tracking.comscore.voc_tc === 'portadilla') {
	
	            /** scrollInfinito & scrollInfinitoHome */
	            if (tracking.comscore.voc_tc === 'portada') {
	              TagManager.set({ scrollInfinito: true });
	              TagManager.set({ scrollInfinitoHome: 1 });
	            }
	
	            /** only news sets **********************************************************************************************/
	          } else {
	
	            /** news defaults */
	            TagManager.set({
	              slot: '',
	              modulosRotacion: tracking.comscore.modulosRotacion,
	              idNoticia: tracking.comscore.idNoticia
	            });
	
	            /** titular */
	            if (tracking.comscore.voc_tn.indexOf(".") > -1) {
	              TagManager.set({ titular: window.voc_tn.substring(0, voc_tn.indexOf(".")) });
	            } else {
	              TagManager.set({ titular: tracking.comscore.voc_tn });
	            }
	          }
	
	          /** Agregamos seccion de tracking para play y summum de buscador **/
	          trackUtils.setTrackBuscadorPlaySummum(TagManager);
	
	          /** error page set **********************************************************************************************/
	          if (tracking.root.httpStatus !== '200') {
	            TagManager.set({ errorPagina: '404' });
	          }
	
	          /** updata vocVars */
	          window.voc_se = TagManager.get().seccion;
	          window.voc_s1 = TagManager.get().subseccion1;
	          window.voc_s2 = TagManager.get().subseccion2;
	          window.voc_s3 = TagManager.get().subseccion3;
	          window.voc_s4 = TagManager.get().subseccion4;
	          window.voc_tn = TagManager.get().titular;
	          window.voc_pr = TagManager.get().tipoDominio;
	          window.voc_ed = TagManager.get().edicion;
	          window.voc_tc = TagManager.get().tipoContenido;
	          window.voc_tcnew = TagManager.get().tipoContenidoA;
	          window.voc_ate = TagManager.get().contenidoPremium;
	          window.voc_pl = TagManager.get().plataformaContenido;
	          window.voc_pu = TagManager.get().sistemaPublicacion;
	          window.voc_fep = TagManager.get().fechaPrimeraPublicacion;
	          window.voc_fem = TagManager.get().fechaModificacion;
	          window.voc_adp = TagManager.get().movilidad;
	          window.voc_ho = TagManager.get().origenPortada;
	          window.voc_idi = TagManager.get().idioma;
	          window.voc_tusr = TagManager.get().tipologiaLogin;
	          window.voc_krux = TagManager.get().IDKrux;
	          window.voc_usrid = TagManager.get().IDGigya;
	          window.voc_usrag = TagManager.get().edad;
	          window.voc_usrcp = TagManager.get().codigoPostal;
	          window.voc_usrgen = TagManager.get().genero;
	          window.customService = TagManager.get().sitioRegistro;
	          window.voc_pw_pid = TagManager.get().IDEvolok;
	          window.voc_pw_meter = TagManager.get().productoEvolok;
	          window.voc_pw_count = TagManager.get().nPaginasConsumidas;
	          window.voc_pw_max = TagManager.get().nPaginasPermitidas;
	          window.voc_pw_result = TagManager.get().autorizacionContenido;
	          window.voc_pw_cookie = TagManager.get().idCookieEvolok;
	          window.voc_adb = TagManager.get().adBlockers;
	          window.voc_adbnew = TagManager.get().adBlockersNew;
	          window.voc_au = TagManager.get().firmaAutor;
	          window.id_autor = TagManager.get().fichaAutor;
	          window.voc_or = TagManager.get().origenContenido;
	          window.voc_top = TagManager.get().topics;
	
	          TagManager.track();
	        } catch (ex) {
	          trackUtils.imgTrack('vtm-ready-exception', ex);
	          console.error(ex);
	        }
	      }, function (reason) {
	        trackUtils.imgTrack('vtm-ready-error', reason);
	        console.error(reason);
	      });
	    }, function (reason) {
	      trackUtils.imgTrack('voonto-ready-error', reason);
	      console.error(reason);
	    });
	  }
	} catch (ex) {
	  trackUtils.imgTrack('vtm-error-exception', ex);
	  console.error(ex);
	}

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// trackingVtm.js